var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6486 47.2566H4.57495C4.14862 47.2565 3.72722 47.1654 3.33888 46.9895C2.95054 46.8136 2.60419 46.5569 2.32294 46.2365C2.04169 45.9161 1.83203 45.5394 1.70793 45.1315C1.58383 44.7237 1.54816 44.294 1.6033 43.8713L5.31636 15.3939C5.41052 14.6719 5.76423 14.0089 6.31143 13.5286C6.85863 13.0483 7.56193 12.7836 8.29 12.7839H10.5202C11.248 12.7841 11.9508 13.0491 12.4976 13.5293C13.0443 14.0095 13.3978 14.6722 13.4919 15.3939L17.6486 47.2566Z",
    stroke: "#00A3FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1401 12.7839H38.9975C39.7252 12.7841 40.4281 13.0491 40.9748 13.5293C41.5216 14.0095 41.875 14.6722 41.9692 15.3939L45.6842 43.8713C45.7394 44.2942 45.7037 44.724 45.5794 45.132C45.4552 45.54 45.2454 45.9168 44.9639 46.2373C44.6824 46.5577 44.3358 46.8144 43.9473 46.9902C43.5587 47.1659 43.1371 47.2568 42.7106 47.2566H17.6484",
    stroke: "#00A3FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.52 12.7839H23.6436",
    stroke: "#00A3FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6345 21.777V8.28773C35.6345 7.50042 35.4795 6.72082 35.1782 5.99345C34.8769 5.26607 34.4353 4.60516 33.8786 4.04845C33.3219 3.49174 32.6609 3.05013 31.9336 2.74884C31.2062 2.44755 30.4266 2.29248 29.6393 2.29248C28.852 2.29248 28.0724 2.44755 27.345 2.74884C26.6176 3.05013 25.9567 3.49174 25.4 4.04845C24.8433 4.60516 24.4017 5.26607 24.1004 5.99345C23.7991 6.72082 23.644 7.50042 23.644 8.28773V21.777",
    stroke: "#00A3FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8173 3.29761C17.9953 3.84602 17.3217 4.58909 16.8562 5.46072C16.3908 6.33236 16.148 7.30552 16.1494 8.29365V12.7841",
    stroke: "#00A3FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.18c5e47e5d5a4d3b41c6490970608da4.svg";
export { ForwardRef as ReactComponent };